module.exports = __webpack_public_path__ + "img/arrow-right-icon-dark-grey.2296942c.svg";